export default __webpack_public_path__ + "static/media/card4.548b9e83.jpg";